/*
 * Jira Ticket:
 * Created Date: Thu, 23rd Apr 2020, 13:13:48 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';

export const getManyEmploymentQuery = gql`
  query allEmployments(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: EmploymentFilter
  ) {
    items: allEmployments(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      id
      organisation {
        id
        name
      }
      type
      role
      projects {
        id
        name
      }
      user {
        id
        email
      }
      status
    }
    total: _allEmploymentsMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      count
    }
  }
`;

export default ({ client, params }) => {
  try {
    if (params.target && params.id) {
       let filterVar, filterValue;



       if (params.target === 'email') {
         // For email target, use the actual email value, not ID
         
         filterVar = 'email'; // or whatever your GraphQL schema expects
         filterValue = params.filter.email ;// You'd need to pass this
       } else {
         // Standard ID-based filtering
         filterVar = params.target + 'Id';
         filterValue = params.id;
       }
      params.filter = { ...params.filter, [filterVar]: filterValue };
      delete params.target;
      delete params.id;
    }
    return client.query({
      query: getManyEmploymentQuery,
      variables: {
        filter: params.filter,
        sortField: params.sort && params.sort.field,
        sortOrder: params.sort && params.sort.order,
        page: params.pagination
          ? !params.pagination.page
            ? 0
            : params.pagination.page - 1
          : 0,
        perPage: params.pagination && params.pagination.perPage,
      },
      fetchPolicy: 'network-only',
    });
  } catch (e) {
    if (e.graphQLErrors && e.graphQLErrors.length) {
      const [error] = e.graphQLErrors;
      const message = error.message;
      throw new Error(message);
    }
    throw e;
  }
};
